import React from 'react'
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined'
import { Box, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { StyledBorderLinearProgress } from '../style'

type IconProp = React.ElementType | React.ReactNode

interface IIconBoxProps {
  readonly Icon: IconProp
  readonly title: string
  readonly percentage: number
  readonly value: number
  readonly color: string
}

interface RenderLeadIconProps {
  leadKey: string
  color: string
  size?: 'small' | 'medium' | 'large'
}

export const RenderLeadIcon: React.FC<RenderLeadIconProps> = ({
  leadKey,
  color,
  size = 'medium',
}) => {
  switch (leadKey) {
    case 'new':
      return <PersonAddAlt1OutlinedIcon htmlColor={color} fontSize={size} />
    case 'inProgress':
      return <AccessTimeOutlinedIcon htmlColor={color} fontSize={size} />
    case 'contacted':
      return <ContactMailOutlinedIcon htmlColor={color} fontSize={size} />
    case 'hired':
      return <CheckCircleOutlineOutlinedIcon htmlColor={color} fontSize={size} />
    case 'rejected':
      return <CancelOutlinedIcon htmlColor={color} fontSize={size} />
    case 'spam':
      return <BlockOutlinedIcon htmlColor={color} fontSize={size} />
    case 'synced':
      return <SyncOutlinedIcon htmlColor={color} fontSize={size} />
    default:
      return <PersonAddAlt1OutlinedIcon htmlColor={color} fontSize={size} />
  }
}

const LeadFunnelProgressItem: React.FC<IIconBoxProps> = ({
  Icon,
  title,
  percentage,
  value,
  color,
}) => {
  const theme = useTheme()

  return (
    <Stack direction="row" width="100%" spacing={2} alignItems="center">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.primary.light,
          borderRadius: 1,
          width: 40,
          height: 40,
        }}
      >
        {typeof Icon === 'function' ? <Icon /> : Icon}
      </Box>
      <Stack width="100%" spacing={1}>
        <Stack direction="row" width="100%" justifyContent="space-between">
          <Typography variant="h4" color={color}>
            {title}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Typography variant="h4" color="#A4A8B3">
              {percentage}%
            </Typography>
            <Typography variant="h4" color="#000000">
              {value}
            </Typography>
          </Stack>
        </Stack>
        <StyledBorderLinearProgress variant="determinate" value={percentage} />
      </Stack>
    </Stack>
  )
}

export default LeadFunnelProgressItem
